export default ($axios, reportApiUrl) => ({
  /**
   * [0903] 發佈報告下載
   * @param {string} token 客戶進入外部連結 url的token
   * @returns pdf/其他檔案
   */
  getReportPath(params) {
    return $axios.get(`${reportApiUrl}/ReportPath`, { params });
  },
});
